export const SYSTEM_ANNOUNCEMENT_LOAD = 'SYSTEM_ANNOUNCEMENT_LOAD';
